<template>
  <div v-on:mousemove="checkInactivityMoveMouse">
    <h1 class="h3 mb-3 text-gray-800">
      {{ $t("Atualizar Atividade") }}
    </h1>
    <ModalVerificarPrivado
      v-if="item.privado == 1 && status_privado == false"
      @liberar="status_privado = true"
    />
    <b-card v-else class="shadow" v-on:mousemove="status_privado = !checkInactivity">
      <template v-slot:default>
        <load v-if="loading" />
        <div v-else class="row">
          <div class="col-md-12">
            <table class="table b-table b-table-stacked-lg table-bordered table-sm">
              <tbody>
                <tr>
                  <td>
                    ID: <strong>{{ item.id }}</strong>
                  </td>
                  <td>
                    PROTOCOLO:
                    <strong>{{ item.protocolo }}</strong>
                  </td>
                  <td>
                    CADASTRADO:
                    <strong>{{ item.created_at }}</strong>
                  </td>
                  <td>
                    ATUALIZADO:
                    <strong>{{ item.updated_at }}</strong>
                  </td>
                </tr>

                <tr v-if="item.responsavel">
                  <td>
                    TÉCNICO RESPONSÁVEL: 
                    <strong>{{ item.responsavel.name }}</strong> <span class="badge badge-light"> {{ item.responsavel.tecnico.profissao ?? 'Não informado' }} </span>
                  </td>
                  <td colspan="2">
                    TÉCNICO AUTOR:
                    <strong>{{ item.autor }}</strong>
                  </td>
                  <td>
                    UNIDADE:
                    <strong v-if="item.unidade">{{ item.unidade.nome }}</strong>
                  </td>
                </tr>

                <tr
                  v-if="
                    item.relacao &&
                    item.relacao != '' &&
                    $route.meta.controller != item.relacao.controller
                  "
                >
                  <td colspan="4">
                    <span class="small" v-html="item.relacao.mensagem"></span>
                    <b-link href="#" :to="item.relacao.link"> Ver </b-link>
                  </td>
                </tr>

                <tr>
                  <tr v-if="item.parent_atividade">
                    <td colspan="4">
                      Esta atividade foi replicada de <b-link @click="redirectAtividade(item.parent_atividade)">#{{ item.parent_atividade }} Atividade</b-link>
                    </td>
                  </tr>
                  <tr v-if="item.children_atividades && item.children_atividades.length > 0">
                    <td colspan="4">
                      Histórico de atividades replicadas a partir desta:
                      <ul>
                        <li v-for="atividade in item.children_atividades" :key="atividade.id">
                          <b-link @click="redirectAtividade(atividade.id)">#{{ atividade.id }} - {{ atividade.titulo }}</b-link>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div
          class="alert alert-info bg-gradient-info animate__animated animate__fadeIn d-flex justify-content-start"
          v-if="
            item.status == 41 &&
            item.lista_inscritos.length == 0 &&
            item.participantes.length == 0
          "
        >
          <div class="mr-3">
            <span style="font-size: 28px">
              <i class="fas fa-info-circle"></i>
            </span>
          </div>

          <div>
            O Status desta Atividade foi atualizado para
            <b>Realizado</b>, mas não foi feita a inscrição de nenhum Usuário na aba
            <b>Usuários Inscritos.</b> Recomendamos que insira os Usuários Participantes e
            na sequência faça a confirmação de presença.
          </div>
        </div>

        <b-tabs v-model="tabIndex" content-class="mt-3" v-if="!loading">
          <b-tab title="Detalhes da Atividade" active>
            <div v-if="historicoStatus == false">
              <form @submit.prevent="submit" ref="addItem">
                <div class="row">
                  <!-- Campos Atividades do Scfv -->
                  <form-input
                    v-model="item.tema"
                    grid="12"
                    label="Tema"
                    v-if="camposScfv"
                  />
                  <!-- Campos Atividades do Scfv Tema ou Título-->

                  <form-input
                    v-model="item.titulo"
                    v-if="!camposScfv"
                    grid="12"
                    label="Título"
                    :required="true"
                  />

                  <form-select
                    grid="6"
                    v-model="item.tipo_id"
                    label="Tipo"
                    :itens="tipos"
                    ajuda="'Se você não encontrar o Tipo de Atividade desejado na lista abaixo, adicione um novo na área de Gestão de Parametros ou solicite o cadastro a um Administrador'"
                    @change="verifyType(), verifyTypeReuniao()"
                  />
                  <form-select
                    v-model="item.tipo_servico_id"
                    label="Serviço"
                    grid="6"
                    :itens="servicos"
                    :disabled="disabledServico"
                  />
                  <form-calendar
                    v-model="dataAdd"
                    grid="4"
                    label="Data"
                    :required="true"
                  />

                  <form-calendar
                    v-model="format_hora"
                    grid="4"
                    label="Hora"
                    mode="time"
                  />

                  <form-input
                    v-model="item.duracao"
                    grid="4"
                    label="Duração"
                    placeholder="00:00"
                    v-mask="'##:##'"
                  />

                  <form-select
                    v-model="item.participantes"
                    label="Usuários Inscritos no Grupo"
                    :multiple="true"
                    :itens="usuariosvinculadosFormatados"
                    v-if="camposScfv"
                  />

                  <div
                    v-if="camposScfv"
                    class="col-md-12 mb-2"
                  >
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                      :disabled="!usuariosvinculadosFormatados.length"
                      @click="selecionarTodosUsuariosInscritos"
                    >
                      <i class="fas fa-check-double mr-1"></i>
                      Inscrever Todos
                    </button>
                  </div>

                  <form-select
                    v-else
                    v-model="item.participantes"
                    label="Equipe - Participantes"
                    :multiple="true"
                    :itens="listtecnicos"
                  />

                  <div class="col-md-12 mb-2">
                    <label for="tags-basic"><b>Outros Participantes</b></label>
                    <b-form-tags
                      input-id="tags-basic"
                      v-model="item.outros_participantes"
                      tag-variant="secondary"
                      size="sm"
                      placeholder="Digite o nome completo do participante e pressione Adicionar"
                      add-button-text="Adicionar"
                    ></b-form-tags>
                  </div>

                  <form-input
                    v-model="item.qtde_sem_printuario"
                    grid="2"
                    label="Usuários sem prontuário"
                    type="number"
                    min="0"
                    ajuda="'O quantitativo inserido nesse campo é referente ao número de pessoas que participaram da atividade, que não possuem pronturário aberto no sistema. Esse quantitativo não é contabilizado no RMA, tampouco no relatório de atividade (que demanda a vinculação do usuário para contabilização).'"
                  />

                  <div class="col-md-12">
                    <CamposScfv :item="item" v-if="camposScfv" />
                  </div>

                  <form-input
                    v-model="item.local"
                    grid="12"
                    label="Local da Atividade"
                    v-if="showLocal"
                  />

                  <form-input
                    v-model="item.link_sala_reuniao"
                    grid="12"
                    label="Link da Sala Virtual"
                    v-if="showLocal"
                  />

                  <div
                    class="col-md-12"
                    v-if="camposScfv == false"
                  >
                    <div class="row" v-if="!loading">
                      <form-textarea-editor
                        v-model="item.conteudo"
                        grid="12"
                        label="Conteúdo"
                      />
                    </div>
                  </div>

                  <form-select
                    @change="verificarStatus"
                    grid="4"
                    v-model="item.status"
                    label="Status"
                    :itens="status"
                    :ajuda="ajuda_status"
                  />

                  <form-file
                    @submit="submitFile"
                    multiple
                    btn-text="Iniciar"
                    :progress="progressCompleted"
                    grid="8"
                    ref="inputFile"
                  />
                </div>

                <div class="row pt-4 px-0 d-flex justify-content-end">
                  <form-toggle
                    grid="auto"
                    mt="0"
                    v-model="item.privado"
                    label="Sigilo?"
                  />
                  <a v-if="is_morph" class="btn btn-default" @click="voltar">
                    <i class="mdi mdi-arrow-left" />
                  </a>
                  <router-link v-else to="/dashboard/atividades" class="btn btn-default">
                    <i class="mdi mdi-arrow-left" />
                  </router-link>

                  <b-button
                    :title="$t('Replicar Atividade')"
                    @click.prevent="showMsgBoxClonar"
                    class="py-1"
                    size="sm"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                  >
                    <i class="mdi mdi-content-copy mdi-18px" />
                  </b-button>

                  <a
                    class="btn btn-primary"
                    @click="$bvModal.show('modal-auditoria')"
                    :title="$t('Auditoria')"
                    v-b-tooltip.hover
                  >
                    <i class="mdi mdi-timeline-clock-outline mdi-16px" />
                  </a>

                  <a
                    v-if="
                      $store.state.user.role_details.name == 'Admin' ||
                      $store.state.user.role_details.name == 'Gestor(a)' ||
                      $store.state.user.id == item.user_id
                    "
                    title="Remanejar"
                    class="btn btn-warning py-2"
                    @click="$bvModal.show('modal-remanejar-servico')"
                  >
                    <i class="fas fa-exchange-alt mdi-18px" />
                    {{ $t("Remanejar") }}
                  </a>

                  <b-button
                    :title="$t('Visualizar e Imprimir')"
                    :to="'/dashboard/atividades/show/' + item.id"
                    class="py-1"
                    size="sm"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                  >
                    <i class="mdi mdi-printer mdi-18px" />
                  </b-button>

                  <b-button
                    v-if="item.realizado"
                    :title="$t('Lista de Presença')"
                    @click.prevent="abrirListaPresenca"
                    :disabled="carregandoPresenca"
                    type="button"
                    v-b-tooltip.hover
                    variant="primary"
                  >
                    <span>Lista de Presença</span>
                  </b-button>
                  
                  <button
                    class="btn btn-success btn-submit"
                    data-style="zoom-in"
                    type="submit"
                  >
                    <i class="fas fa-save" />
                    {{ $t("Salvar") }}
                  </button>
                </div>
              </form>

              <div v-if="item.anexos && item.anexos.length > 0">
                <anexos :anexos="item.anexos" />
              </div>

              <modulo-comentario module="Atividade" :id="item.id" />
            </div>
            <div class="row" v-else>
              <div class="col-12">
                <h4 class="font-weight-bold">Registro de Atividade</h4>
              </div>
              <HistoricoStatus
                @voltar="historicoStatus = false"
                :id="item.id"
                :familia="0"
                :status="status_item"
              />
            </div>
          </b-tab>
          <b-tab
            v-if="camposScfv == false && (tipo_coletivo == true || item.realizado)"
            :title="'Usuários Inscritos (' + countInscritos + ')'"
          >
            <ListaUsuariosInscritos
              ref="usuariosInscritos"
              :atividade="item"
            />
          </b-tab>

          <b-tab
            v-if="item.realizado && camposScfv == false"
            :title="'Técnicos participantes (' + item.count_participantes + ')'"
          >
            <ListaTecnicosParticipantes
              :atividade="item"
              @atualizado="atualizarPresencaTecnicos"
            />
          </b-tab>

          <b-tab
            v-if="
              tipo_coletivo == true &&
              camposScfv == false &&
              item.lista_desvinculados.length > 0
            "
            title="Histórico de Usuários Desvinculados"
          >
            <ListaUsuariosDesnviculados
              :atividade="item"
              :desvinculados="item.lista_desvinculados"
            />
          </b-tab>
        </b-tabs>
      </template>
    </b-card>
    <ModalPresencaParticipantes
      v-if="item.realizado"
      :participantes="participantes"
      :participantes-presentes="
        camposScfv ? (item.participantes_presentes || []) : presencaInscritos.presentes
      "
      :participantes-ausentes="
        camposScfv ? (item.participantes_ausentes || []) : presencaInscritos.ausentes
      "
      :save-url="camposScfv ? undefined : 'api/dashboard/atividades/' + item.id + '/presenca'"
      :model="morph_type"
      :model-id="item.id"
      @presentes="presentes"
      @ausentes="ausentes"
      @salvo="atualizarInscritos"
    />

    <status-historico
      :model="model"
      modulo="Atividade"
      titulo_modulo="ATIVIDADE"
      :id="item.id"
      :status-anterior="statusAnterior"
      :status-atual="statusAtual"
      :status="status_item"
      @submit="submit"
    />

    <ModalRemanejarServico
      servico="atividades"
      :servico_id="item.id"
      :tecnico_id="item.responsavel.tecnico.id"
    />

    <ModalAuditoria
      servico="atividades"
      :servico_id="item.id"
    />
  </div>
</template>

<script>
import ModalRemanejarServico from "../../../../../resources/js/dashboard/components/widgets/ModalRemanejarServico";
import CamposScfv from "./includes/CamposScfv";
import ListaUsuariosInscritos from "./includes/ListaUsuariosInscritos";
import ListaUsuariosDesnviculados from "./includes/ListaUsuariosDesnviculados";
import ListaTecnicosParticipantes from "./includes/ListaTecnicosParticipantes";
import ModalPresencaParticipantes from "./includes/ModalPresencaParticipantes";
import HistoricoStatus from "./HistoricoStatus";
import ModalVerificarPrivado from "./includes/ModalVerificarPrivado";
import ModalAuditoria from '../../../../../resources/js/dashboard/components/widgets/ModalAuditoria';
export default {
  name: "Edit",
  props: ["morph", "morphAtividadeId", "usuariosvinculados", "morph_type"],
  components: {
    ModalRemanejarServico,
    ModalPresencaParticipantes,
    HistoricoStatus,
    CamposScfv,
    ListaUsuariosInscritos,
    ListaUsuariosDesnviculados,
    ListaTecnicosParticipantes,
    ModalVerificarPrivado,
    ModalAuditoria,
  },
  data() {
    return {
      loading: true,
      status_privado: false,
      item: {
        conteudo: null,
        tipo_id: null,
        atividadesable_type: null,
        participantes: [],
        participantes_presentes: [],
        participantes_ausentes: [],
        responsavel: { tecnico: {} }
      },
      servicos: [],
      tecnicos: [],
      tipos: [],
      files: {},
      progressCompleted: 0,
      participantes: [],
      carregandoPresenca: false,
      presencaInscritos: { presentes: [], ausentes: [] },
      is_morph: false,
      model: "Atividade",
      status: {},
      status_item: [],
      statusAtual: "",
      statusAnterior: "",
      historicoStatus: false,
      showTogglePrivate: false,
      showPrivate: false,
      camposScfv: false,
      dadosScfv: {},
      tipo_coletivo: false,
      disabledServico: false,
      countInscritos: 0,
      tabIndex: 0,
      page: "detalhes",
      dataAdd: moment().format("YYYY/MM/DD"),
      showLocal: false,
      ajuda_status:`<b>ABERTO:</b> O status <b>Aberto</b> é indicado quando o usuário da plataforma registra uma atividade. No caso, esse status aponta que foi iniciado um registro e, posteriormente, será possível o gerenciamento da atividade registrada e a indicação de outros status;<br><br>
            <b>EM ANDAMENTO:</b> O status <b>Em Andamento</b> é registrado como meio de informar que a atividade está em desenvolvimento ou que ocorrerá em data posterior;<br><br>
            <b>CANCELADO :</b> O status <b>Cancelado</b> é registrado quando uma atividade anteriormente registrada, por algum motivo, não irá mais ocorrer;<br><br>
            <b>REALIZADO:</b> O status <b>Realizado</b> é registrado quando o usuário da Plataforma gerencia o status da atividade para informar que a mesma foi realizada conforme a previsão;<br><br>
            <b>FINALIZADO:</b> O Status <b>Finalizado</b> é indicado como meio para o usuário da Plataforma encerrar algum registro;<br><br>
            <b>INATIVO:</b>O status inativo é atribuído a um registro quando não há mais necessidade de mantê-lo por várias razões. Normalmente, isso acontece devido à duplicação de informações ou à ausência de dados relevantes. Quando um registro é marcado como inativo, isso indica que ele não está mais em uso ativo e não será mais atualizado ou mantido.`
    };
  },
  computed: {
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-atividade-privado");
      }
      return this.$root.isIdle;
    },
    pessoas() {
      const participantes = this.item.participantes_array;

      const mappessoas = participantes.map((elem) => ({
        id: elem.id,
        searchTerms: [elem.nome, elem.nome_social],
        value: " <b>" + elem.nome + "</b>",
      }));

      return mappessoas;
    },
    listtecnicos() {
      const tecnicos = this.tecnicos;

      const maptecnicos = tecnicos.map((elem) => ({
        id: elem.id,
        value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
      }));
      return maptecnicos;
    },
    usuariosvinculadosFormatados() {
      const lista = this.usuariosvinculados || [];

      const usuarios = lista.map((elem) => ({
        id: elem.id,
        searchTerms: elem.searchTerms || [elem.nome, elem.nome_completo, elem.nome_social],
        value: elem.value || elem.nome || elem.name,
      }));

      if (this.item.participantes_array) {
        this.item.participantes_array.forEach((user) => {
          const existe = usuarios.find((elem) => elem.id == user.id);

          if (!existe) {
            usuarios.push({
              id: user.id,
              searchTerms: [user.nome, user.nome_social],
              value: user.nome,
            });
          }
        });
      }

      return usuarios;
    },
  },
  mounted() {
    this.morph ? (this.is_morph = true) : (this.is_morph = false);
    this.getTecnicos();
    this.getStatus();
    this.getTipos();
    this.getItem();
    this.getServicos();
    this.getStatusFinais();

    this.$root.$on("usuariosvinculado", () => {
      this.countInscritos = this.countInscritos + 1;
    });
    this.$root.$on("usuariodesvinculado", () => {
      this.countInscritos = this.countInscritos - 1;
      this.getItem();
    });
    this.$bvModal.show("verificar-atividade-privado");
  },
  methods: {
    voltar() {
      this.$emit('voltar')
      this.$emit('reload')
    },
    verifyType(load = false) {
      this.showTogglePrivate = false;
      if (load == false) {
        this.item.privado = 0;
      }

      this.tipos.filter((e) => {
        if (e.id == this.item.tipo_id && e.value == "DISCUSSÃO DE CASO") {
          this.showTogglePrivate = true;
        }
      });
    },
    verifyTypeReuniao() {
      this.showLocal = false;

      if (this.item.tipo_id) {
        this.tipos.filter((e) => {
          if (e.id == this.item.tipo_id && e.value == "REUNIÃO") {
            this.showLocal = true;
          }
        });
      }
    },
    presentes(presentes) {
      if (this.camposScfv) {
        this.item.participantes_presentes = presentes;
      } else {
        this.presencaInscritos.presentes = presentes;
      }
    },
    ausentes(ausentes) {
      if (this.camposScfv) {
        this.item.participantes_ausentes = ausentes;
      } else {
        this.presencaInscritos.ausentes = ausentes;
      }
    },
    atualizarInscritos() {
      if (!this.camposScfv && this.$refs.usuariosInscritos) {
        this.$refs.usuariosInscritos.getUsuarios();
      }
    },
    async abrirListaPresenca() {
      if (this.camposScfv) {
        this.getParticipantes(this.item.participantes_array);
        return;
      }

      this.carregandoPresenca = true;
      try {
        const response = await axios.get(`api/dashboard/atividades/${this.item.id}/presenca`);
        this.presencaInscritos = {
          presentes: response.data.presentes,
          ausentes: response.data.ausentes,
        };
        this.getParticipantes(response.data.participantes);
      } catch (error) {
        this.$snack.danger({ button: false, text: 'Não foi possível carregar a lista de presença.' });
      } finally {
        this.carregandoPresenca = false;
      }
    },
    atualizarPresencaTecnicos(presenca) {
      this.item.participantes_presentes = presenca.presentes;
      this.item.participantes_ausentes = presenca.ausentes;
    },
    selecionarTodosUsuariosInscritos() {
      const usuarios = Array.isArray(this.usuariosvinculadosFormatados)
        ? this.usuariosvinculadosFormatados
        : [];

      const ids = usuarios
        .filter((usuario) => usuario && usuario.id !== undefined && usuario.id !== null)
        .map((usuario) => usuario.id);

      this.$set(this.item, "participantes", ids);
    },
    getItem(id = null) {
      var id = id ? id : this.is_morph ? this.morphAtividadeId : this.$route.params.id;
      this.loading = true;
      this.item.conteudo = "";

      axios
        .get(`api/dashboard/atividades/${id}`)
        .then((response) => {
          this.item = response.data.data;

          if (this.item.participantes_array && this.item.participantes_array.length > 0) {
            this.item.participantes = this.item.participantes_array.map(user => user.id);
          }

          this.item.conteudo = response.data.data.conteudo;
          this.format_hora = response.data.data.hora;
          this.dataAdd = this.item.data;
          this.item.tipo_id = response.data.data.tipo_id;
          this.countInscritos = this.item.lista_inscritos.length;
          this.statusAnterior = this.item.status;

          //if (
          //  this.item.tipo == "AÇÕES COLETIVAS DE CARÁTER NÃO CONTINUADO" ||
          //  this.item.tipo == "ATENDIMENTO COLETIVO" ||
          //  this.item.tipo == "ATIVIDADES PAIF" ||
          // this.item.tipo == "ATIVIDADES PAEFI" ||
          //  this.item.tipo == "ATIVIDADE DE CARÁTER CONTINUADO"
          //) {
          //  this.tipo_coletivo = true;
          //} else {
          //  this.tipo_coletivo = false;
          //}

          // Conforme CARD/634, o campo deve permanecer verdadeiro para qualquer tipo.
          if(this.item.tipo == "ARTICULACAO COM A REDE" || 
             this.item.tipo == "REUNIÃO" || 
             this.item.tipo == "DISCUSSAO DE CASO" ||
             this.item.tipo == "DISCUSSÃO DE CASO"){

            this.tipo_coletivo = false;

          }else{

            this.tipo_coletivo = true;

          }

          if (this.item.atividadesable_type && this.item.atividadesable_type == "Modules\\Scfv\\Entities\\ScfvGrupo") {
            this.camposScfv = true;
          }
          if (this.item.privado == 1) {
            this.showTogglePrivate = true;
          }

          this.verifyTypeReuniao();
        })
        .catch((error) => {
          swal.fire({
            title: "Ops!",
            html: "O item não foi carregado corretamente<br>" + error,
            icon: "error",
          });
        })
        .finally(() => {
          this.loading = false;
          this.verifyType(true);
        });
    },
    submitFile(files) {
      this.files = files;
    },
    getTecnicos() {
      axios.get(`api/dashboard/atividades/tecnicos/get`).then((response) => {
        this.tecnicos = response.data;
      });
    },
    getTipos() {
      axios.get(`api/dashboard/atividades/tipos`).then((response) => {
        this.tipos = response.data;
      });
    },
    getStatus() {
      axios.get(`api/dashboard/status/atividades`).then((response) => {
        this.status = response.data;
      });
    },
    verificarStatus(status) {
      this.statusAtual = status;

      const result = this.status_item.filter((item) => item.id == status);
      if (result[0].final == 1) {
        //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
        this.$bvModal.show("status-historico-" + this.model);
      }
    },
    getStatusFinais() {
      axios
        .post(`api/dashboard/get/status/finais`, {
          model: this.model,
          module: this.model,
        })
        .then((response) => {
          this.status_item = response.data;
        });
    },
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      this.item.data = moment(this.dataAdd, "YYYY-MM-DD").format("DD/MM/YYYY");

      const dataatual = moment(new Date()).format("YYYY-MM-DD");

      //A atividade poderá ser apontada como status realizada, quando a data for posterior a data de realização efetiva da atividade;
      const statusRealizado = this.status_item.find(
        (item) => item.descricao == "REALIZADO"
      );

    //     console.log(this.item.status == statusRealizado.id);

    //   if (this.item.status == statusRealizado.id && dataatual < this.item.data) {
    //     swal.fire({
    //       title: "Alerta",
    //       html:
    //         "A Atividade só pode ser atualizada para Realizada, quando a data for posterior a data de realização efetiva da Atividade",
    //       icon: "warning",
    //     });
    //     ladda.stop();
    //     return false;
    //   }

      if (this.format_hora) {
        this.item.hora = moment(this.format_hora).format("HH:mm");
      }

      let formData = new FormData();

      if (this.files.length > 0 && this.files.length != undefined) {
        for (const i of Object.keys(this.files)) {
          formData.append("files[]", this.files[i]);
        }
      } else {
        formData.append("files", this.files);
      }

      for (var key in this.item) {
        formData.append(key, this.item[key]);
      }

      for (const i of Object.keys(this.item["outros_participantes"])) {
        formData.append("outros_participantes[]", this.item["outros_participantes"][i]);
      }

      axios
        .post(`api/dashboard/update/atividades`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          ladda.stop();
          this.getItem();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
        })
        .catch((e) => {
          this.$snack.success({
            button: false,
            text: e,
          });
          ladda.stop();
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
          this.verifyType(true);
        });
    },
    getParticipantes(value) {
      this.participantes = Array.isArray(value) ? value : [];

      this.$nextTick(() => {
        this.$bvModal.show("modalParticipantes");
      });
    },
    getServicos() {
      axios.get(`api/dashboard/atendimento/servicos`).then((response) => {
        this.servicos = response.data;

        if (this.morph && this.morph.type == "ScfvGrupo") {
          //Força o Select a receber o ID do Serviços do SCFV
          this.item.tipo_servico_id = this.servicos.filter(function (item) {
            return item.value == "SERVIÇO DE CONVIVÊNCIA E FORTALECIMENTO DE VÍNCULOS" 
              ? item.id
              : null;
          });
          this.disabledServico = true;
        }
      });
    },
    checkInactivityMoveMouse() {
      if (this.item.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-atividade-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
    showMsgBoxClonar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Esta ação vai criar uma cópia desta atividade incluindo uma numeração após o título e todos os campos e inscritos poderão ser atualizados se necessário. Ao concluir a replica o sistema deve direcionar você para nova atividade que permanecerá sempre conectada a atividade de origem.",
          {
            title: "Atenção!",
            size: "sm",
            buttonSize: "sm",
            okVariant: "info",
            okTitle: "Replicar",
            cancelTitle: "Cancelar",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.clonarAtividade();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    clonarAtividade() {
      this.loading = true;

      var id = id ? id : this.is_morph ? this.morphAtividadeId : this.$route.params.id;
      axios.get(`api/dashboard/atividades/clonar/${id}`)
        .then((response) => {
          const data = response.data.data;

          this.$snack.success({
            button: false,
            text: data.message,
          });

          if (this.is_morph) {
            this.voltar()
          } else {
            this.$router.push(`/dashboard/atividades/edit/${data.atividade.id}`, () => {
            setTimeout(() => {
             this.getItem(data.atividade.id);
              this.loading = false;
            }, 3 * 1000);
          });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      },

    async redirectAtividade(id) {
      this.loading = true;

      if (this.is_morph) {
            this.$emit('editar', {id:id});
       } else {
             await this.$router.push({ name: 'edit-atividade', params: { id: id } }, () => {
      setTimeout(() => {
              this.getItem(id);
              this.loading = false;
            });
         });
      }



    }
  },
};
</script>
